import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { parseAsString, useQueryState } from 'nuqs';
import { useGetBoard, useOpportunityReportingActivityLogQuery } from '../../../../../../queries';
import { useOpportunityReportingFilterBar } from '../../hooks/useOpportunityReportingFilterBar';
import { FilterBar } from '../FilterBar';
import { ActivityLogTable } from './ActivityLogTable';
import { StagesTable } from './StagesTable';
import { styleSheet } from './styles';

interface DetailsTabProps {
	boardId: string | null;
}

export const DetailsTab: React.FC<DetailsTabProps> = ({ boardId }) => {
	const [activityDateFrom, setActivityDateFrom] = useQueryState('activityFrom', parseAsString.withDefault(''));
	const [activityDateTo, setActivityDateTo] = useQueryState('activityTo', parseAsString.withDefault(''));

	const filterBar = useOpportunityReportingFilterBar({ boardId });

	const getBoardQuery = useGetBoard({ boardId: boardId ?? '' });
	const stages = getBoardQuery.data?.stages;
	const isBoardInvalid = !!boardId && getBoardQuery.isFetched && getBoardQuery.isError;

	const enabled = !!boardId;

	const activityQuery = useOpportunityReportingActivityLogQuery({
		boardId: boardId ?? '',
		fromDate: activityDateFrom ? moment(activityDateFrom).startOf('day').toISOString() : undefined,
		toDate: activityDateTo ? moment(activityDateTo).endOf('day').toISOString() : undefined,
		enabled,
	});

	const allActivityEntries = activityQuery.data?.pages.flatMap(p => p.values) ?? [];

	return (
		<div className={css(styleSheet.container)}>
			{boardId ? <FilterBar stages={stages} isBoardInvalid={isBoardInvalid} filterBar={filterBar} /> : null}
			<StagesTable filterRequest={filterBar.apiFilterRequest} boardId={boardId ?? ''} enabled={enabled} />
			<ActivityLogTable
				data={allActivityEntries}
				isLoading={activityQuery.isPending}
				isLoadingMore={activityQuery.isFetchingNextPage}
				hasNextPage={activityQuery.hasNextPage}
				onLoadMore={() => {
					void activityQuery.fetchNextPage();
				}}
				activityDateFrom={activityDateFrom}
				activityDateTo={activityDateTo}
				onActivityDateChange={(from: string, to: string) => {
					void setActivityDateFrom(from || null);
					void setActivityDateTo(to || null);
				}}
				boardId={boardId}
			/>
		</div>
	);
};
